<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
.table-dashboard tfoot tr td {
    background: #1f2248;
    color: #fff;
}
.new-pemungut{
    border-bottom: 1px solid #000000 !important;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="LAPORAN AKAUN BELUM TERIMA">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <!-- <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                    </div> -->
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>DAERAH</td>
                                <td>CUKAI TANAH BELUM KUTIP (RM)</td>
                                <td>TUNGGAKAN CUKAI TANAH (RM)</td>
                                <td>CUKAI PETAK (RM)</td>
                                <td>TUNGGAKAN CUKAI PETAK (RM)</td>
                                <td>DENDA (RM)</td>
                                <td>TUNGGAKAN DENDA (RM)</td>
                                <td>CUKAI TALI AIR (RM)</td>
                                <td>TUNGGAKAN CUKAI TALI AIR (RM)</td>
                                <td>NOTIS (RM)</td>
                                <td>TUNGGAKAN NOTIS (RM)</td>
                                <td>JUMLAH (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <td style="text-align: left">{{ dt.daerah }}</td>
                                    <td style="text-align: right">{{ dt.cukai_tanah }}</td>
                                    <td style="text-align: right">{{ dt.tunggakan_cukai_tanah }}</td>
                                    <td style="text-align: right">{{ dt.cukai_petak }}</td>
                                    <td style="text-align: right">{{ dt.tunggakan_cukai_petak }}</td>
                                    <td style="text-align: right">{{ dt.denda }}</td>
                                    <td style="text-align: right">{{ dt.tunggakan_denda }}</td>
                                    <td style="text-align: right">{{ dt.cukai_tali_air }}</td>
                                    <td style="text-align: right">{{ dt.tunggakan_cukai_tali_air }}</td>
                                    <td style="text-align: right">{{ dt.notis }}</td>
                                    <td style="text-align: right">{{ dt.tunggakan_notis }}</td>
                                    <td style="text-align: right">{{ dt.jumlah }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="10" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><b>JUMLAH</b></td>
                                <td style="text-align: right"><b>{{table.jml_cukai_tanah}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_tunggakan_cukai_tanah}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_cukai_petak}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_tunggakan_cukai_petak}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_denda}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_tunggakan_denda}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_cukai_tali_air}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_tunggakan_cukai_tali_air}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_notis}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_tunggakan_notis}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_total}}</b></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                    <!-- <a bg-color="warning" class="w-button warning--bg size--md mr3 mr3" :href="service_laporan+'kutipan/laporan/akaun_belum_terima?pdf=1&user_id='+this.auth.user.id+
            '&tarikh_dari=' + cari.tarikh_dari +
            '&tarikh_hingga=' + cari.tarikh_hingga +
            '&jabatan_id=' + cari.jabatan_id" download="laporan_akaun_belum_terima.pdf">
                        <w-icon>fal fa-file-pdf</w-icon>&nbsp;Pdf
                    </a> -->
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/akaun_belum_terima" },
                { label: "Laporan", route: "/kutipan/laporan/akaun_belum_terima" },
                {
                    label: "Laporan Akaun Belum Terima",
                    route: "/kutipan/laporan/akaun_belum_terima",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.getQueryData();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/akaun_belum_terima?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&jabatan_id=" + this.cari.jabatan_id,'_blank');
            },
        pdf() {
            window.open(this.service_laporan+'kutipan/laporan/akaun_belum_terima?pdf=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&jabatan_id=" + this.cari.jabatan_id,'_blank');
        },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/akaun_belum_terima?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&jabatan_id=" + this.cari.jabatan_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
